
import React from 'react';
import styles from './Hints.module.scss';
import Panel from 'components/Shared/Panel/Panel';

export const hintsArray = [
    <>
        <h4>Joining the Game</h4>
        Choose one of the <span className={styles.yellow}>4 podiums</span> to play from — either solo or with a teammate. <br />
        Once all podiums are filled, the game begins!
    </>,
    <>
        <h4>The Goal</h4>
        Your aim: find the most <span className={styles.green}>pointless</span> answer possible — an answer that no one else thought of! <br />
        The fewer people who gave your answer in the real survey, the better your score.
    </>,
    <>
        <h4>Main Rounds</h4>
        The game has <span className={styles.yellow}>4 main rounds</span>. <br />
        In each, a question is asked and every team must give one answer. <br />
        • You <span className={styles.red}>can’t reuse</span> an answer already given by another team. <br />
        • A <span className={styles.red}>wrong answer</span> scores <span className={styles.yellow}>100 points</span>. <br />
        • The lower your score, the better!
    </>,
    <>
        <h4>Team Decisions</h4>
        If you’re in a team, both players can suggest answers privately. <br />
        Then you’ll <span className={styles.green}>vote together</span> on which answer to submit. <br />
        Cooperation is key — pick wisely to avoid common answers!
    </>,
    <>
        <h4>Advancing to the Final</h4>
        After <span className={styles.yellow}>4 rounds</span>, the team with the <span className={styles.green}>lowest total score</span> advances to the Final Round. <br />
        If there’s a tie, the game ends there — no final this time!
    </>,
    <>
        <h4>The Final Round</h4>
        The last team standing has <span className={styles.yellow}>60 seconds</span> to think of as many answers as they can. <br />
        You’ll then get <span className={styles.yellow}>3 chances</span> to submit your best guesses. <br />
        Find a <span className={styles.green}>pointless answer</span> — one that nobody said in the survey — and you win! <br />
        Miss all 3? <span className={styles.red}>Game over!</span>
    </>,
    <>
        <h4>Winning the Game</h4>
        The ultimate victory goes to the team that finds a <span className={styles.green}>pointless answer</span> in the final. <br />
        It’s all about clever thinking, teamwork, and staying obscure. <br />
        Good luck — and may your answers be truly <span className={styles.green}>pointless</span>!
    </>,
];


// React component to display all hints
const Hints = ({ show, removeBreaks, onClose }) => {
    if (!show) return null;

    return (
        <div className={styles.hintsBackground}>
            <Panel
                wrapperClassName={`${styles.hintsContainer} ${removeBreaks ? styles.noBreaks : ''}`}
                className={styles.hintsInner}
            >
                {/* Close button */}
                <button className={styles.closeButton} onClick={onClose}>
                    ×
                </button>

                {hintsArray.map((hint, idx) => (
                    <div key={idx} className={styles.hint}>
                        {hint}
                    </div>
                ))}
            </Panel>
        </div>
    );
};

export default Hints;